import { Component, viewChild } from '@angular/core';
import appPackage from '../../../../package.json';
import { UserActionComponent } from './user-action/user-action.component';
import { SynHeaderComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'application-header',
  templateUrl: './base-header.component.html',
  styleUrls: ['./base-header.component.scss'],
  imports: [UserActionComponent, SynHeaderComponent],
})
export class BaseHeaderComponent {
  appName: string = `${appPackage.title}`;

  readonly synHeader = viewChild.required<SynHeaderComponent>('header');

  get nativeElement() {
    return this.synHeader().nativeElement;
  }
}
